import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDrop"><Path d="M13.6034 2.67324C12.7072 1.78047 11.2928 1.78047 10.3966 2.67324C9.31718 3.74848 7.72874 5.47132 6.40698 7.47861C5.09262 9.47465 4 11.8144 4 14.1111C4 18.475 7.58878 21.9999 12 21.9999C16.4112 21.9999 20 18.475 20 14.1111C20 11.8144 18.9074 9.47465 17.593 7.47861C16.2713 5.47132 14.6828 3.74848 13.6034 2.67324Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrop;
